import { type WorkspaceAgentMutationToolName } from '@air/analytics';

/**
 * When the client should invalidate the current view after a `toolResult` with backend `mutated`.
 *
 * `runFinished` batches until the open session's run ends. `toolResult` flushes as soon as that
 * call signals `mutated` so long-gap tools that create files can appear on the board between batches.
 */
export const WORKSPACE_AGENT_CACHE_INVALIDATION_FLUSH_WHEN = {
  RUN_FINISHED: 'runFinished',
  TOOL_RESULT: 'toolResult',
} as const;

export type WorkspaceAgentCacheInvalidationFlushWhen =
  (typeof WORKSPACE_AGENT_CACHE_INVALIDATION_FLUSH_WHEN)[keyof typeof WORKSPACE_AGENT_CACHE_INVALIDATION_FLUSH_WHEN];

type WorkspaceAgentCacheInvalidationFlushConfig = {
  flushWhen: WorkspaceAgentCacheInvalidationFlushWhen;
};

/**
 * Variant creation can sit idle between batches, so `bulk_variants` flushes on each mutating
 * `toolResult`. Other writes batch until `Run.finished`.
 */
export const WORKSPACE_AGENT_CACHE_INVALIDATION_FLUSH_BY_TOOL = {
  bulk_variants: { flushWhen: WORKSPACE_AGENT_CACHE_INVALIDATION_FLUSH_WHEN.TOOL_RESULT },
} as const satisfies Partial<Record<WorkspaceAgentMutationToolName, WorkspaceAgentCacheInvalidationFlushConfig>>;
